<template>
  <div class="view-profile">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <login-layout v-if="!loading">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <gappt-menu class="ma-4" :user="user"></gappt-menu>
      </v-row>
      <div class="pa-6">
        <v-form
          autocomplete="off"
          lazy-validation
          class="ma-3">

          <v-alert type="error" v-if="formState.error.length" dismissible>
            {{ formState.error }}
          </v-alert>
          <v-alert type="success" v-if="formState.success.length" dismissible>
            {{ formState.success }}
          </v-alert>

          <v-row justify="center">
            <v-avatar
              size="155"
            >
              <v-img
                v-if="user.avatar"
                :src="user.avatar"
                size="155" />
              <v-icon v-else size="155">account_circle</v-icon>
            </v-avatar>
            <input type="hidden"
                   role="uploadcare-uploader"
                   name="avatar"
                   :data-public-key="fileUploader.publicKey"
                   data-images-only
                   data-image-shrink="800x800"
                   data-crop="1:1"
                   data-clearable />
            <button v-if="user.avatar"
                    class="remove-avatar"
                    @click="removePhoto"
                    >Clear</button>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.email"
                label="E-mail"
                name="email"
                prepend-icon="email"
                type="text"
                color="primary darken-4"
                :disabled="true"
                :error="(!$v.user.email.required||!$v.user.email.email)&&formState.validation"
                :error-messages="(!$v.user.email.required||!$v.user.email.email)&&formState.validation?'E-mail is required':''"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.phone"
                label="Phone"
                name="phone"
                prepend-icon="phone"
                type="text"
                color="primary darken-4"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.first_name"
                label="First name *"
                name="first_name"
                prepend-icon="person"
                type="text"
                color="primary darken-4"
                :error="!$v.user.first_name.required&&formState.validation"
                :error-messages="!$v.user.first_name.required&&formState.validation?'First name is required':''"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.last_name"
                label="Last name *"
                name="last_name"
                prepend-icon="person"
                type="text"
                color="primary darken-4"
                :error="!$v.user.last_name.required&&formState.validation"
                :error-messages="!$v.user.last_name.required&&formState.validation?'Last name is required':''"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-if="user.admin">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="login.password"
                label="New password"
                name="password"
                prepend-icon="lock"
                :append-icon="formState.passwordMode ? 'visibility_off' : 'visibility'"
                @click:append="() => (formState.passwordMode = !formState.passwordMode)"
                :type="formState.passwordMode ? 'password' : 'text'"
                color="primary darken-4"
                :error="formState.validation && $v.login.password.$error"
                :error-messages="$v.login.password.$error ? passwordErrors($v) : ''"
                autocomplete="new-password"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="login.repeatPassword"
                label="Repeat new password"
                name="repeatPassword"
                prepend-icon="lock"
                :append-icon="formState.passwordMode ? 'visibility_off' : 'visibility'"
                @click:append="() => (formState.passwordMode = !formState.passwordMode)"
                :type="formState.passwordMode ? 'password' : 'text'"
                color="primary darken-4"
                :error="formState.validation && $v.login.repeatPassword.$error"
                :error-messages="$v.login.repeatPassword.$error ? passwordRepeatErrors($v) : ''"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-card-actions class="pa-3 pr-0 d-flex justify-end">
            <v-btn
              large
              text
              to="/"
            >
              Back
            </v-btn>

            <v-btn large
                   color="primary darken-4 white--text"
                   :disabled="formState.sending"
                   @click="submit">
              Save
            </v-btn>
          </v-card-actions>

        </v-form>
      </div>
    </login-layout>
  </div>
</template>
<script>
    import Vue from "vue";
    import { required, email } from 'vuelidate/lib/validators';
    import {
      passwordRepeatValidators,
      passwordErrorMessage,
      passwordRepeatErrorMessage,
      optionalPasswordValidators
    } from '../helpers/passwordHelpers'
    import GapptMenu from "./Menu";
    import uploadcare from 'uploadcare-widget'

    export default {
        name: "Profile",

        components: { GapptMenu },

        data() {
            return {
                user: {
                  first_name: '',
                  last_name: '',
                  email: '',
                },
                login: {
                  password: '',
                  repeatPassword: '',
                },
                formState: {
                    sending: false,
                    validation: false,
                    passwordMode: true,
                    error: '',
                    success: '',
                    changed: false
                },
                fileUploader: {
                    widget: null,
                    publicKey: process.env.VUE_APP_UPLOADCARE_PUBLIC_KEY,
                }
            }
        },

        validations: {
            user: {
                first_name: { required },
                last_name: { required },
                email: { required, email },
            },
            login: {
                password: optionalPasswordValidators,
                repeatPassword: passwordRepeatValidators('login', 'password')
            }
        },

        computed: {
            loading () {
                return this.$store.state.loading
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$sessionGuard.check(to, from, next)
        },

        beforeRouteLeave(to, from, next) {
          if (from.name == 'profile' && this.formState.changed) {
            if (confirm('Are you sure you want to leave this page? You have unsaved changes.')) {
              next()
            } else {
              next(false)
            }
          } else {
            next()
          }
        },

        watch: {
          'user': {
            handler: function () {
              this.formState.changed = true
            },
            deep: true
          }
        },

        mounted() {
            this.getData().then(()=>{
                this.fileUploader.widget = uploadcare.SingleWidget('[role=uploadcare-uploader]');
                let that = this
                this.fileUploader.widget.onUploadComplete(function(info) {
                    that.user.avatarUUID = info.uuid
                    that.user.avatar = info.cdnUrl
                    that.user.avatarModifiers = info.cdnUrlModifiers
                    that.fileUploader.widget.value(null)
                })
                this.formState.changed = false
            }).catch(()=>{});
        },

        methods: {
            removePhoto() {
              this.user.avatar = ''
              this.user.avatarUUID = ''
              this.user.avatarModifiers = ''
            },

            submit() {
                this.$v.$reset()
                this.formState.validation = true;
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.formState.sending = false;
                } else {
                    this.formState.validation = false
                    this.$store.commit('loadingOn')
                    this.formState.sending = true
                    this.formState.error = ''

                    this.$sessionService.update(Object.assign({}, this.user, this.login))
                        .then(() => {
                            this.formState.success = 'The profile data has been saved.';
                            this.login.password = ''
                            this.login.repeatPassword = ''
                        })
                        .catch((error) => {
                            this.formState.error = error.response.data.error;
                        }).finally(() => {
                            this.formState.sending = false
                            this.$store.commit('loadingOff')
                            this.$v.user.$reset()
                            window.scrollTo({top:0});
                        });
                }
            },

            async getData() {
                this.$store.commit('loadingOn')

                return await this.$sessionService.current().then(
                    response => {
                        this.user = response.login
                        this.login.password = ''
                        this.login.repeatPassword = ''
                    }).catch((error) => {
                        this.$router.replace({name: 'login'})
                        throw error
                    }).finally(() => this.$store.commit('loadingOff'))
            },

            passwordErrors($v) {
                return passwordErrorMessage($v.login.password)
            },

            passwordRepeatErrors($v) {
                return passwordRepeatErrorMessage($v.login.repeatPassword)
            }
        }
    }
</script>

<style>
  .uploadcare--widget {
    position: absolute;
    margin-top: 110px;
    margin-left: 110px;
  }
  .uploadcare--widget__button_type_open {
    padding: 0 5px;
    font-size: 12px;
    background: #fff;
    color: transparent;
    box-shadow: 0 1px 1px 0 rgba(65, 69, 73, 0.3), 0 1px 3px 1px rgba(65, 69, 73, 0.15);
    width: 50px;
  }
  .uploadcare--widget__button_type_open:before {
    content: "Change";
    color: #757575;
  }
  .uploadcare--widget__button_type_open:hover:before,
  .uploadcare--widget__button_type_open:focus:before {
    color: #fff;
  }
  .uploadcare--widget__button_type_open:hover,
  .uploadcare--widget__button_type_open:focus {
    padding: 0 3px;
    font-size: 12px;
    background: #e65100;
    color: transparent;
    box-shadow: 0 1px 1px 0 rgba(65, 69, 73, 0.3), 0 1px 3px 1px rgba(65, 69, 73, 0.15);
    outline: none;
  }
  .remove-avatar {
    position: absolute;
    margin-top: 136px;
    margin-left: 112px;
    padding: 0 5px;
    font-size: 12px;
    background: #fff;
    color: transparent;
    box-shadow: 0 1px 1px 0 rgba(65, 69, 73, 0.3), 0 1px 3px 1px rgba(65, 69, 73, 0.15);
    width: 50px;
    color: #f58228;
    border-radius: 5px;
  }
  .view-profile .v-messages__message {
    white-space: pre;
  }
</style>